export const GET_CUSTOMERS_API = "/customers/";

export const ADD_CUSTOMER_API = "/customers/";

export const DELETE_CUSTOMER_API = "/customers/";

export const UPDATE_CUSTOMER_API = "/customers/";


// WEBPACK FOOTER //
// ./src/apis/customers.js